import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;


export const fetchApprovals = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "approval_select",
            "action": "LIST_ALL",
            "variables": `{}`
        })
    });
}


export const fetchUsers = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "user_select",
            "action": "GET_USERS",
            "variables": `{}`
        })
    });
}


export const fetchGroups = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "group_select",
            "action": "GET_GROUPS",
            "variables": `{}`
        })
    });
}


export const fetchApprovalById = (accessToken, idApprovalRules) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "approval_rules_select",
            "action": "GET_BY_ID",
            "findOne": "true",
            "variables": JSON.stringify({
                'id_approval_rules': idApprovalRules
            })
        })
    });
};


export const getCompanies = (id_user_action, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'user_select',
            'action': 'SELECTCOMPANIES_OC',
            // 'findOne': "true",
            'variables': JSON.stringify({ 'id_user_action': id_user_action })
        })
    })
}

export const insertApprovals = (accessToken, data) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            "process": "approval_rules_alter",
            "action": "INSERT",
            "variables": data
        })
    });
}

export const updateApproval = (accessToken, data) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            'process': 'approval_rules_alter',
            'action': "UPDATE",
            'variables': data
        })
    })
}

